module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": _vm.showConnectionError,
      "type": "error"
    }
  }, [_vm._v("Couldn't Connect to Post Service! Please Comeback Later!")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": "",
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": "",
      "sm6": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "item-value": "id",
      "item-text": "name",
      "items": _vm.campaigns,
      "label": "Campaign Filter",
      "hide-details": "",
      "outlined": "",
      "auto-select-first": ""
    },
    on: {
      "change": _vm.search
    },
    model: {
      value: (_vm.filter.campaignID),
      callback: function($$v) {
        _vm.$set(_vm.filter, "campaignID", $$v)
      },
      expression: "filter.campaignID"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": true,
      "height": 56,
      "label": "Filter by Handle",
      "outlined": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filter.instagramHandle),
      callback: function($$v) {
        _vm.$set(_vm.filter, "instagramHandle", $$v)
      },
      expression: "filter.instagramHandle"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": "",
      "sm6": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "hide-details": true,
      "item-text": "name",
      "item-value": "id",
      "items": _vm.clients,
      "outlined": true,
      "label": "Client",
      "auto-select-first": ""
    },
    on: {
      "change": _vm.search
    },
    model: {
      value: (_vm.filter.clientID),
      callback: function($$v) {
        _vm.$set(_vm.filter, "clientID", $$v)
      },
      expression: "filter.clientID"
    }
  })], 1), _vm._v(" "), (_vm.currentUserRole !== _vm.userRoles.INFLUENCER && _vm.currentUserRole !== _vm.userRoles.CLIENT) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": "",
      "sm6": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "hide-details": true,
      "item-text": "text",
      "item-value": "value",
      "items": _vm.statuses,
      "outlined": true,
      "label": "Status",
      "auto-select-first": ""
    },
    on: {
      "change": _vm.search
    },
    model: {
      value: (_vm.filter.filterStatus),
      callback: function($$v) {
        _vm.$set(_vm.filter, "filterStatus", $$v)
      },
      expression: "filter.filterStatus"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md1": "",
      "sm6": ""
    }
  }, [_c('v-btn', {
    staticClass: "mt-2 primary",
    on: {
      "click": _vm.resetFilter
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": "",
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.statusReportHeaders,
      "items": _vm.reportData,
      "item-key": "id",
      "options": _vm.pagging,
      "server-items-length": _vm.pagging.totalItems
    },
    on: {
      "update:options": function($event) {
        _vm.pagging = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.handle",
      fn: function(ref) {
        var item = ref.item;

        return [(item.author.tiktokHandle) ? _c('a', {
          attrs: {
            "href": 'https://www.tiktok.com/@' + item.author.tiktokHandle,
            "target": "_blank"
          }
        }, [_c('img', {
          attrs: {
            "src": "/static/img/tiktok-32.png",
            "width": "20px"
          }
        }), _vm._v(" @" + _vm._s(item.author.tiktokHandle))]) : (item.author.youtubeHandle) ? _c('a', {
          attrs: {
            "href": 'https://youtube.com/' + item.author.youtubeHandle,
            "target": "_blank"
          }
        }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(item.author.youtubeHandle))], 1) : _c('a', {
          attrs: {
            "href": 'https://instagram.com/' + item.author.instagramHandle,
            "target": "_blank"
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "#000000",
            "small": ""
          }
        }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(item.author.instagramHandle))], 1)]
      }
    }, {
      key: "item.status",
      fn: function(ref) {
        var item = ref.item;

        return _vm._l((item.labels), function(label) {
          return _c('div', {
            key: label.text
          }, [_c('v-chip', {
            staticClass: "ma-1",
            attrs: {
              "small": "",
              "color": label.color,
              "outlined": label.outlined,
              "dark": label.dark
            }
          }, [_vm._v("\n                  " + _vm._s(label.text) + "\n                  "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v(_vm._s(label.icon))])], 1)], 1)
        })
      }
    }, {
      key: "item.submittedDate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_vm._v("\n                " + _vm._s(item.submittedDate) + " "), (item.hasReport || item.postURL) ? _c('v-icon', {
          attrs: {
            "color": "green",
            "data-toggle": "tooltip",
            "data-placement": "bottom",
            "title": "Live Post"
          }
        }, [_vm._v("mdi-check")]) : _vm._e()], 1)]
      }
    }, {
      key: "item.payoutDueDate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_vm._v("\n                " + _vm._s(item.payoutDueDate) + " "), (item.payoutSubmitted) ? _c('v-icon', {
          attrs: {
            "color": "green",
            "data-toggle": "tooltip",
            "data-placement": "bottom",
            "title": "Payout Submitted"
          }
        }, [_vm._v("mdi-check")]) : _vm._e()], 1)]
      }
    }, {
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "mb-2"
        }, [_c('v-btn', {
          staticClass: "mt-2 primary",
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.viewDetailPost(item)
            }
          }
        }, [_vm._v("\n                View Post "), _c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-magnify")])], 1), _vm._v(" "), _c('v-btn', _vm._g({
          staticClass: "mt-2 primary",
          attrs: {
            "to": ("/campaignPayoutsInternal?influencerID=" + (item.influencerID) + "&campaignID=" + (item.campaignID)),
            "target": "_blank",
            "disabled": !item.payout,
            "small": ""
          }
        }, _vm.on), [_vm._v("\n                View Submitted Payouts "), _c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-image-multiple")])], 1), _vm._v(" "), _c('v-menu', {
          attrs: {
            "bottom": "",
            "left": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-btn', _vm._g({
                staticClass: "mt-2 primary",
                attrs: {
                  "small": ""
                }
              }, on), [_vm._v("Action")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-list', _vm._l((_vm.menuOptions), function(menuItem, i) {
          return _c('v-list-item', {
            key: i,
            on: {
              "click": function($event) {
                return _vm.actionPostBy(menuItem.action, item)
              }
            }
          }, [_c('v-list-item-content', [_vm._v(_vm._s(menuItem.name))]), _vm._v(" "), _c('v-list-item-action', [_c('v-icon', [_vm._v(_vm._s(menuItem.icon))])], 1)], 1)
        }), 1)], 1)], 1)]
      }
    }], null, true)
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.loading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.loading = $event
      }
    }
  }), _vm._v(" "), _c('view-post-modal', {
    attrs: {
      "post": _vm.viewPostData,
      "csActions": _vm.showCsEditAction,
      "saleActions": _vm.showSaleAction,
      "clientActions": _vm.showClientEditAction,
      "influencerActions": _vm.showInfluencerEditAction,
      "cs_inf_chatbox": _vm.show_cs_inf_chatbox,
      "postAbuseHistory": _vm.showPostAbuseHistory,
      "postReviewApproved": _vm.showPostReviewApproved,
      "postHistory": _vm.showPostHistory,
      "userObj": _vm.user,
      "value": _vm.viewPostDialog
    },
    on: {
      "csApproved": _vm.csApproveFromView,
      "saleReleased": _vm.saleReleasePost,
      "editPost": _vm.editPostFromView,
      "mainPostChanged": _vm.reloadPostView
    },
    model: {
      value: (_vm.viewPostDialog),
      callback: function($$v) {
        _vm.viewPostDialog = $$v
      },
      expression: "viewPostDialog"
    }
  }), _vm._v(" "), _c('edit-post-modal', {
    attrs: {
      "post": _vm.editPostData,
      "postAbuseHistory": true,
      "value": _vm.editPostDialog,
      "userObj": _vm.user
    },
    on: {
      "postUpdated": function($event) {
        return _vm.getStatusReport()
      }
    },
    model: {
      value: (_vm.editPostDialog),
      callback: function($$v) {
        _vm.editPostDialog = $$v
      },
      expression: "editPostDialog"
    }
  }), _vm._v(" "), _c('assign-campaign-modal', {
    attrs: {
      "post": _vm.assignCampaignPostData
    },
    on: {
      "success": function($event) {
        return _vm.assignedCampaign($event)
      }
    },
    model: {
      value: (_vm.assignCampaignDialog),
      callback: function($$v) {
        _vm.assignCampaignDialog = $$v
      },
      expression: "assignCampaignDialog"
    }
  }), _vm._v(" "), _c('map-influencer-modal', {
    attrs: {
      "post": _vm.mapInfluencerPostData
    },
    on: {
      "successInfluencerMap": function($event) {
        return _vm.getStatusReport()
      }
    },
    model: {
      value: (_vm.mapInfluencerDialog),
      callback: function($$v) {
        _vm.mapInfluencerDialog = $$v
      },
      expression: "mapInfluencerDialog"
    }
  }), _vm._v(" "), _c('submission-review-multiple-modal', {
    attrs: {
      "posts": _vm.selected,
      "internalApprove": true
    },
    on: {
      "successBulkApprove": function($event) {
        return _vm.getStatusReport()
      }
    },
    model: {
      value: (_vm.submissionReviewMultipleDialog),
      callback: function($$v) {
        _vm.submissionReviewMultipleDialog = $$v
      },
      expression: "submissionReviewMultipleDialog"
    }
  }), _vm._v(" "), _c('add-post-to-campaign', {
    attrs: {
      "value": _vm.addPostToCampaign,
      "campaign": _vm.campaignDataForAddPost,
      "postID": _vm.postIdToUpdate,
      "post": _vm.addPost
    },
    on: {
      "done": _vm.postAdded
    },
    model: {
      value: (_vm.addPostToCampaign),
      callback: function($$v) {
        _vm.addPostToCampaign = $$v
      },
      expression: "addPostToCampaign"
    }
  }), _vm._v(" "), _c('change-post-status-modal', {
    attrs: {
      "post": _vm.postDataForChangeStatus,
      "postIds": _vm.changePostIds
    },
    on: {
      "updated": function($event) {
        return _vm.getStatusReport()
      }
    },
    model: {
      value: (_vm.changeStatusDialog),
      callback: function($$v) {
        _vm.changeStatusDialog = $$v
      },
      expression: "changeStatusDialog"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "hide-overlay": "",
      "persistent": "",
      "width": "250"
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary"
    }
  }, [_c('v-card-text', {
    staticClass: "loading-dialog-text"
  }, [_vm._v("\n        Please stand by\n        "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "secondary"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fd06f5bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Post/statusReport.vue
// module id = 2324
// module chunks = 0